import { Factory } from 'rosie';

Factory.define('SelectedSuggestedReply').attr('item');

Factory.define('SelectedSuggestedReplyDefaults')
  .extend('SelectedSuggestedReply')
  .attr('item', suggestedReply => Factory.attributes('SuggestedReplyWithDefaults', suggestedReply, {}));
